import { ArenaMuralPost } from 'modules/arena/mural/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Avatar } from 'shared/components/ui/Avatar';
import { Button } from 'shared/components/ui/Button';
import { cn } from 'shared/utils/cn';

interface ArenaPostCardProps {
  post: ArenaMuralPost;
  onRemove: (id: string) => void;
  onRestore: (id: string) => void;
  onResolveReport: (id: string) => void;
}

const KIND_LABEL: Record<ArenaMuralPost['kind'], string> = {
  racha: 'RACHA',
  aviso: 'AVISO',
  'sem-quadra': 'SEM QUADRA',
};

export function ArenaPostCard({ post, onRemove, onRestore, onResolveReport }: ArenaPostCardProps) {
  const isRemoved = post.state === 'removido';

  return (
    <Card className={cn(isRemoved && 'opacity-60')}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-3">
          <Avatar name={post.authorName} size="sm" />
          <div>
            <p className="text-sm font-medium text-ink">{post.authorName}</p>
            <p className="text-xs text-ink-secondary">
              {post.timeAgoLabel}
              {post.isOfficial && ' · aviso oficial'}
            </p>
          </div>
        </div>

        <div className="flex flex-shrink-0 items-center gap-2">
          <Badge tone="neutral">{KIND_LABEL[post.kind]}</Badge>
          {isRemoved && <Badge tone="danger">Removido</Badge>}
          {post.reportCount > 0 && <Badge tone="warning">{post.reportCount} denúncia(s)</Badge>}
        </div>
      </div>

      <p className="mt-3 text-sm text-ink">{post.text}</p>

      {(post.courtInfo || post.spotsLabel) && (
        <p className="mt-2 text-xs text-ink-secondary">
          {[post.courtInfo, post.spotsLabel].filter(Boolean).join(' · ')}
        </p>
      )}

      <div className="mt-4 flex flex-wrap gap-2">
        {post.reportCount > 0 && !isRemoved && (
          <Button variant="ghost" className="px-3 py-1 text-xs" onClick={() => onResolveReport(post.id)}>
            Resolver denúncia
          </Button>
        )}

        {isRemoved ? (
          <Button variant="ghost" className="px-3 py-1 text-xs" onClick={() => onRestore(post.id)}>
            Restaurar
          </Button>
        ) : (
          <Button
            variant="ghost"
            className="border-danger px-3 py-1 text-xs text-danger hover:bg-danger-soft"
            onClick={() => onRemove(post.id)}
          >
            Remover
          </Button>
        )}
      </div>
    </Card>
  );
}
